module.exports = __webpack_public_path__ + "1e5d264b414b806b00c2a8d9853846af.png";